import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  list_item: {
    alignItems: "center",
    display: "flex",
    justifyContent: "flex-start",
  },
}));
